import React from 'react'

const Mentor = () => {
  return (
    <div>
      Mentor Page
    </div>
  )
}

export default Mentor
